<template>
  <div class="viewDashBoard">
    <transition
      name="fade"
      mode="out-in"
      @beforeLeave="beforeLeave"
      @enter="enter"
      @afterEnter="afterEnter"
    >
      <div key="1" v-if="loader" class="white-row loader-route">
        <div class="lds-sub-ripple">
          <div></div>
          <div></div>
        </div>
      </div>
      <div v-else key="2" class="container-fluid">
        <div class="white-row">
          <section class="top-heading-section-invoice">
            <div class=" invoices-tab">
              <div class="row">
                <div class="col-sm-4">
                  <h4 class="global-style-heading">
                    Invoices:
                    <a
                      @click.prevent="refreshInvoiceTable"
                      href=""
                      class="refreshData"
                      ><i class="fas fa-redo-alt"></i
                    ></a>
                  </h4>
                </div>
                <div class="col-sm-4">
                  <div class="general-filters form-action-top-area">
                    <div class="form-actions text-right">
                      <router-link
                        class="btn btn-primary"
                        :to="{
                          path: '/invoices/create-manual-invoice'
                        }"
                        tag="button"
                      >
                        <i class="fas fa-plus-circle"></i> Generate Manual
                        Invoice
                      </router-link>
                    </div>
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="general-filters form-action-top-area">
                    <div class="form-actions text-right">
                      <router-link
                        class="btn btn-primary"
                        :to="{
                          path: '/invoices/create-invoice'
                        }"
                        tag="button"
                      >
                        <i class="fas fa-plus-circle"></i> Generate Invoice
                      </router-link>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Adding Filers -->
              <div class="general-filters">
                <div class="row">
                  <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                    <form @submit.prevent="getInvoicesData">
                      <div class="row">
                        <div class="col-sm-4">
                          <div class="row">
                            <div class="form-group custom-date-picker">
                              <label for="from_date">&nbsp;</label>
                              <datepicker
                                :minimumView="'day'"
                                :maximumView="'month'"
                                :initialView="'month'"
                                :format="customFormatterfromdate"
                                placeholder="From"
                                :input-class="'form-control'"
                                :clear-button="true"
                                :value="formData.from_date"
                                @cleared="onClearDateFromDate"
                              >
                                <span
                                  slot="afterDateInput"
                                  class="animated-placeholder"
                                >
                                  <i class="far fa-calendar-alt"></i>
                                </span>
                              </datepicker>
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-4">
                          <div class="row">
                            <div class="form-group custom-date-picker">
                              <label for="to_date">&nbsp;</label>
                              <datepicker
                                :minimumView="'day'"
                                :maximumView="'month'"
                                :initialView="'month'"
                                :format="customFormattertodate"
                                placeholder="To"
                                :input-class="'form-control'"
                                :clear-button="true"
                                @cleared="onClearDateToDate"
                                :value="formData.to_date"
                              >
                                <span
                                  slot="afterDateInput"
                                  class="animated-placeholder"
                                >
                                  <i class="far fa-calendar-alt"></i>
                                </span>
                              </datepicker>
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-4">
                          <div class="row">
                            <div class="form-group full-width-md">
                              <label for="gender" class="control-label"
                                >&nbsp;</label
                              >
                              <div class="input-group">
                                <input
                                  @keyup.enter="getInvoicesData"
                                  v-model="formData.search"
                                  type="text"
                                  class="form-control"
                                  placeholder="Search..."
                                />
                                <div class="input-group-append">
                                  <button
                                    class="btn btn-secondary"
                                    type="button"
                                  >
                                    <i class="fa fa-search"></i>
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-4">
                          <div class="row">
                            <div class="form-group">
                              <label for="brand_id" class="control-label"
                                >&nbsp;</label
                              >
                              <Select2
                                v-model="formData.brand_id"
                                :options="project_brand_options"
                                :settings="{
                                  placeholder: 'Project Brands',
                                  allowClear: true,
                                  multiple: true
                                }"
                              />
                            </div>
                          </div>
                        </div>

                        <div class="col-sm-4">
                          <div class="row">
                            <div class="form-group">
                              <label for="brand_id" class="control-label"
                                >&nbsp;</label
                              >
                              <Select2
                                v-model="formData.emp_id"
                                :options="project_employee_options"
                                :settings="{
                                  placeholder: 'Team Lead / Sales Person',
                                  allowClear: true
                                }"
                              />
                            </div>
                          </div>
                        </div>

                        <div class="col-sm-4">
                          <div class="row">
                            <div class="form-group">
                              <label for="client_id" class="control-label"
                                >&nbsp;</label
                              >
                              <Select2
                                v-model="formData.client_id"
                                :options="client_options"
                                :settings="{
                                  placeholder: 'Clients',
                                  allowClear: true
                                }"
                              />
                            </div>
                          </div>
                        </div>

                        <div class="col-sm-4">
                          <div class="row">
                            <div class="form-group">
                              <label for="brand_id" class="control-label"
                                >&nbsp;</label
                              >
                              <Select2
                                @change="getInvoicesData(1)"
                                v-model="formData.status"
                                :options="invoice_status"
                                :settings="{
                                  placeholder: 'Select Status',
                                  allowClear: true
                                }"
                              />
                            </div>
                          </div>
                        </div>

                        <div class="col-sm-4">
                          <div class="row">
                            <div class="form-group">
                              <label for="brand_id" class="control-label"
                                >&nbsp;</label
                              >
                              <Select2
                                @change="getInvoicesData(1)"
                                v-model="formData.number_per_page"
                                :options="page_numbers"
                                :settings="{
                                  placeholder: 'Select Lead Per page'
                                }"
                              />
                            </div>
                          </div>
                        </div>

                        <div class="col-sm-4">
                          <div class="row">
                            <div class="form-actions">
                              <button
                                type="submit"
                                class="btn btn-primary default-global-btn"
                              >
                                Search
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section class="invoices-area">
            <transition
              name="fade"
              mode="out-in"
              @beforeLeave="beforeLeave"
              @enter="enter"
              @afterEnter="afterEnter"
            >
              <div key="1" v-if="data_loader" class="white-row loader-route">
                <div class="lds-sub-ripple">
                  <div></div>
                  <div></div>
                </div>
              </div>
              <div v-else key="2" class=" invoices-tab">
                <div class="table-responsive">
                  <div class="table-responsive">
                    <table class="table">
                      <thead>
                        <tr>
                          <th class="text-right">Action</th>
                          <th>Invoice Number</th>
                          <th>Project</th>
                          <th>Brand</th>
                          <th>Client</th>
                          <th>Total</th>
                          <th>Remaining</th>
                          <th>Status</th>
                          <th>Issue Date</th>
                          <th>Due Date</th>
                        </tr>
                      </thead>
                      <tbody
                        v-if="
                          typeof invoice_data.data !== 'undefined' &&
                            Object.keys(invoice_data.data).length
                        "
                      >
                        <tr
                          v-for="(invoice, inv_index) in invoice_data.data"
                          :key="inv_index"
                        >
                          <td>
                            <!-- Dropdown -->
                            <div class="header-top">
                              <dropdown>
                                <template slot="icon"
                                  ><i class="fas fa-ellipsis-v"></i
                                ></template>
                                <template slot="body">
                                  <ul class="list-group">
                                    <li class="list-group-item">
                                      <a
                                        v-if="
                                          invoice.invoice_payments_count == 0
                                        "
                                        @click.prevent="
                                          copyURL(copy_url + invoice.id)
                                        "
                                        href="#"
                                        data-toggle="tooltip"
                                        title="Copy Url!"
                                        class="invoice-icon"
                                      >
                                        <p class="invoice-icon">
                                          <i class="fas fa-copy"></i>
                                        </p>
                                      </a>
                                    </li>
                                    <li class="list-group-item">
                                      <a
                                        @click.prevent="
                                          downloadInvoice(inv_index)
                                        "
                                        data-toggle="tooltip"
                                        title="Download!"
                                        class="invoice-icon"
                                        data-placement="top"
                                        href="#"
                                      >
                                        <p class="invoice-icon">
                                          <i class="fas fa-download"></i>
                                        </p>
                                      </a>
                                    </li>
                                    <li class="list-group-item">
                                      <router-link
                                        v-if="
                                          invoice.invoice_payments_count == 0
                                        "
                                        class="invoice-icon"
                                        title="Edit!"
                                        data-placement="top"
                                        :to="{
                                          path:
                                            '/invoices/edit-invoice/' +
                                            invoice.id
                                        }"
                                        tag="a"
                                      >
                                        <p class="invoice-icon">
                                          <i class="far fa-edit"></i>
                                        </p>
                                      </router-link>
                                    </li>
                                  </ul>
                                </template>
                              </dropdown>
                            </div>
                          </td>
                          <td>
                            <router-link
                              class="invoice-title color-blk customize-global-link gl-lk-blk"
                              :to="{ path: '/invoices/show/' + invoice.id }"
                              tag="a"
                            >
                              {{ invoice.invoice_number }}
                            </router-link>
                            <a
                              v-if="invoice.is_manual == 'yes'"
                              href="#"
                              @click.prevent="showInvoiceStatusModal(inv_index)"
                            >
                              Change Status
                            </a>
                          </td>

                          <td>{{ invoice.project_name }}</td>
                          <td>{{ invoice.brand_name }}</td>
                          <td>{{ invoice.client_name }}</td>

                          <td>
                            <p
                              v-if="invoice.status == 'partial'"
                              class="invoice-total bold-cls"
                            >
                              Total Installments :
                              {{ invoice.total_installments | numFormat }}
                              <br />
                              Installment Amount :
                              {{ invoice.currency_symbol }}
                              {{ invoice.partial_total | numFormat("0.00") }}
                              <br />
                              Total : {{ invoice.currency_symbol }}
                              {{ invoice.total | numFormat }} <br />
                            </p>
                            <p v-else class="invoice-total bold-cls">
                              {{ invoice.currency_symbol }}
                              {{ invoice.total | numFormat }}
                            </p>
                          </td>
                          <td>
                            <p class="invoice-total bold-cls">
                              {{ invoice.currency_symbol }}
                              {{
                                invoice.total_remaning_amount
                                  | numFormat("0.00")
                              }}
                            </p>
                          </td>
                          <td>
                            <p
                              v-if="
                                invoice.status == 'partial' &&
                                  invoice.invoice_payments_count ==
                                    invoice.total_installments
                              "
                              class="invoice-status success"
                            >
                              {{ invoice.status }} Paid
                            </p>
                            <p
                              v-else
                              :class="[
                                invoice.status == 'paid'
                                  ? 'invoice-status success'
                                  : 'invoice-status danger'
                              ]"
                            >
                              {{ invoice.status }}
                            </p>
                          </td>

                          <td>
                            <p class="">
                              {{ invoice.issue_date }}
                            </p>
                          </td>
                          <td>
                            <p class="">
                              {{ invoice.due_date }}
                            </p>
                          </td>
                        </tr>
                      </tbody>
                      <tbody v-else>
                        <tr>
                          <td colspan="12">
                            <no-record-found></no-record-found>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </transition>
            <div class="row">
              <div class="col-sm-12">
                <pagination
                  class="pagination justify-content-center"
                  :data="invoice_data"
                  :limit="1"
                  @pagination-change-page="getInvoicesData"
                ></pagination>
              </div>
            </div>
          </section>
        </div>
      </div>
    </transition>
    <!-- ProjectMember Modal -->
    <modal
      name="change-invoice-status-modal"
      height="auto"
      width="60%"
      :scrollable="true"
    >
      <div class="ModalLoader">
        <div class="general-form">
          <change-status-component v-on:get-data-from-sub="getSubComponentValue" :prop_invoice_id="prop_invoice_id"></change-status-component>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import norecordfound from "../../../components/no-record-found";
import Dropdown from "bp-vuejs-dropdown";
import Datepicker from "vuejs-datepicker";
import Select2 from "v-select2-component";

import change_status from "./change-status/index.vue";

export default {
  components: {
    "no-record-found": norecordfound,
    Datepicker,
    Select2,
    Dropdown,
    "change-status-component" : change_status,
  },
  computed: {
    getActiveUserData() {
      return this.$store.state.auth;
    }
  },
  data() {
    return {
      prop_invoice_id : null,
      prop_invoice_index : null,
      invoice_data: {},
      loader: true,
      data_loader: true,
      copy_url: null,
      formData: {
        search: "",
        brand_id: null,
        emp_id: null,
        number_per_page: 20,
        from_date: null,
        to_date: null,
        client_id: null,
        status: null
      },
      project_brand_options: null,
      project_employee_options: null,
      client_options: null,
      invoice_status: [
        {
          id: "paid",
          text: "Paid"
        },
        {
          id: "unpaid",
          text: "Unpaid"
        },
        {
          id: "partial",
          text: "Partial"
        },
        {
          id: "cancelled",
          text: "Cancelled"
        }
      ],
      page_numbers: [
        {
          id: 20,
          text: 20
        },
        {
          id: 100,
          text: 100
        },
        {
          id: 300,
          text: 300
        },
        {
          id: 500,
          text: 500
        }
      ]
    };
  },
  mounted() {
    document.title = this.$router.app._route.meta.pageTitle;
    this.copy_url = window.app_url + "/pay-on-workbench/";
    this.loader = false;
    this.getemployees();
    this.getprojectbrands();
    this.getClients();
    this.getInvoicesData();
  },
  methods: {
    getSubComponentValue(data) {
      this.$set(this.invoice_data.data, this.prop_invoice_index, data);
    },
    showInvoiceStatusModal(invoice_index) {
      this.prop_invoice_index = invoice_index;
      this.prop_invoice_id = this.invoice_data.data[this.prop_invoice_index].id;
      this.$modal.show("change-invoice-status-modal");
    },
    hideInvoiceStatusModal() {
      this.$modal.hide("change-invoice-status-modal");
    },
    async getClients() {
      const $this = this;
      const data = $this.$store.dispatch("getHttp", {
        url: "/filters/get-clients"
      });
      await data.then(function(response) {
        if (typeof response !== "undefined") {
          $this.client_options = response.data.data;
        }
      });
    },
    async getemployees() {
      const $this = this;
      const data = $this.$store.dispatch("getHttp", {
        url: "/filters/get-employees"
      });
      await data.then(function(response) {
        if (typeof response !== "undefined") {
          $this.project_employee_options = response.data.data;
        }
      });
    },
    async getprojectbrands() {
      const $this = this;
      const data = $this.$store.dispatch("getHttp", {
        url: "/filters/get-project-brand"
      });
      await data.then(function(response) {
        if (typeof response !== "undefined") {
          $this.project_brand_options = response.data.data;
        }
      });
    },
    onClearDateFromDate() {
      this.formData.from_date = null;
    },
    onClearDateToDate() {
      this.formData.to_date = null;
    },
    customFormatterfromdate(val) {
      const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ];
      var new_val =
        months[val.getMonth()] + " " + val.getDate() + ", " + val.getFullYear();
      this.formData.from_date = new_val;
      return new_val;
    },
    customFormattertodate(val) {
      const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ];
      var new_val =
        months[val.getMonth()] + " " + val.getDate() + ", " + val.getFullYear();
      this.formData.to_date = new_val;
      return new_val;
    },
    copyURL(url) {
      const el = document.createElement("textarea");
      el.value = url;
      el.setAttribute("readonly", "");
      el.style.position = "absolute";
      el.style.left = "-9999px";
      document.body.appendChild(el);
      const selected =
        document.getSelection().rangeCount > 0
          ? document.getSelection().getRangeAt(0)
          : false;
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      if (selected) {
        document.getSelection().removeAllRanges();
        document.getSelection().addRange(selected);
      }
      alert("Url Copied");
    },
    refreshInvoiceTable() {
      this.getInvoicesData();
    },
    async downloadInvoice(inv_index) {
      const $this = this;
      $this.$store.dispatch("generalLoader", {
        response: true
      });
      let inv_id = $this.invoice_data.data[inv_index].id;
      await window
        .axios({
          url:
            "invoices/download/" +
            inv_id +
            "?timezone=" +
            Intl.DateTimeFormat().resolvedOptions().timeZone,
          method: "GET",
          responseType: "blob" // important
        })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            $this.invoice_data.data[inv_index].invoice_number + ".pdf"
          ); //or any other extension
          document.body.appendChild(link);
          link.click();
          $this.$store.dispatch("generalLoader", {
            response: false
          });
        });
    },
    async getInvoicesData(page = 1, action = null) {
      const $this = this;
      $this.data_loader = true;
      const data = $this.$store.dispatch("getHttp", {
        url:
          "invoices" +
          "?" +
          "&search=" +
          this.formData.search +
          "&brand_id=" +
          this.formData.brand_id +
          "&emp_id=" +
          this.formData.emp_id +
          "&from_date=" +
          this.formData.from_date +
          "&number_per_page=" +
          this.formData.number_per_page +
          "&status=" +
          this.formData.status +
          "&client_id=" +
          this.formData.client_id +
          "&to_date=" +
          this.formData.to_date +
          "&page=" +
          page +
          "&timezone=" +
          Intl.DateTimeFormat().resolvedOptions().timeZone
      });
      await data.then(function(response) {
        if (typeof response !== "undefined") {
          $this.invoice_data = response.data;
          $this.data_loader = false;
        }
      });
    },
    beforeLeave(element) {
      this.prevHeight = getComputedStyle(element).height;
    },
    enter(element) {
      const { height } = getComputedStyle(element);

      element.style.height = this.prevHeight;

      setTimeout(() => {
        element.style.height = height;
      });
    },
    afterEnter(element) {
      element.style.height = "auto";
    }
  }
};
</script>

<style lang="scss" scoped>
body .white-row.loader-route {
  top: 0;
}
.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: opacity;
  transition-property: height, opacity;
  transition-timing-function: ease;
  overflow: hidden;
}
section {
  padding: 25px 0;
  border-bottom: 1px solid #ebebeb;
  &.top-heading-section-invoice {
    border-bottom: none;
    padding-bottom: 0;
    padding-top: 0;
    // .general-filters {
    //   .form-actions {
    //     padding: 0;
    //     button {
    //       padding: 6px 25px;
    //       margin-left: 0;
    //     }
    //   }
    // }
    .general-filters {
      &.form-action-top-area {
        .form-actions {
          padding: 0;
          width: 100%;
          button {
            padding: 6px 25px;
            margin-left: 0;
          }
        }
      }
      .form-group {
        width: 95%;
        .input-group {
          input {
            border-radius: 3px !important;
            background: #f9f9f9;
            letter-spacing: 0.28px;
            font-size: 14px;
            padding: 3px 15px;
            color: #364460;
            border: none;
            font-weight: 200;
            height: auto;
          }
          button {
            background: #f9f9f9;
            color: #3b4c54;
            border: none;
            padding: 4px 8px;
          }
        }
      }
      .form-actions {
        width: 95%;
        button {
          width: 100%;
          margin-left: 0;
          padding: 5px 0;
        }
        &.inline-btn {
          text-align: right;
          width: 100%;
          button {
            width: auto;
            margin-left: 0;
            padding: 5px 20px;
            margin: 0 10px;
            &:last-child {
              margin-right: 0;
            }
          }
        }
      }
    }
    .sub-heading {
      padding: 10px 0;
      margin: 0;
    }
  }
  &.invoices-area {
    h4 {
      padding: 0;
    }
    .table-responsive {
      table {
        margin-bottom: 0;
        thead {
          th {
            letter-spacing: 0.28px;
            color: #2a1c0b;
            font-weight: 200;
            white-space: nowrap;
          }
        }
        tbody {
          tr {
            td {
              vertical-align: middle;
              white-space: nowrap;
              p {
                margin-bottom: 0px;
                color: #323f54;
                font-weight: 300;
                letter-spacing: 0.28px;
                &.invoice-title {
                  letter-spacing: 0.28px;
                  font-weight: bold;
                }
                &.invoice-total {
                  font-weight: bold;
                }
                &.invoice-status {
                  font-size: 10px;
                  border-radius: 10px;
                  text-transform: capitalize;
                  font-weight: bold !important;
                  line-height: 20px !important;
                  padding: 0 10px;
                  text-align: center;
                  &.success {
                    background: rgba(0, 128, 0, 0.72);
                    color: #fff !important;
                  }
                  &.danger {
                    background: red;
                    color: #fff !important;
                  }
                }
                &.invoice-icon {
                  display: inline-block;
                  background: #1190ee;
                  color: #fff !important;
                  padding: 6px 10px;
                  border-radius: 5px;
                }
              }
              .download-box {
                .invoice-icon {
                  margin-left: 5px;
                  &:first-child {
                    margin-left: 0;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  &.top-heading-section-invoice {
  }
  .pagination {
    padding-top: 30px;
  }
}
</style>
